var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefineIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.41895 0.0253906H15.4961C15.8739 0.0253906 16.2016 0.163397 16.4795 0.441406C16.7575 0.719272 16.8955 1.04701 16.8955 1.4248V12.168C16.8955 12.5443 16.7575 12.8706 16.4795 13.1475C16.2016 13.4245 15.8739 13.5625 15.4961 13.5625H3.32324L3.31543 13.5693L1.19434 15.6914C1.08505 15.8006 0.968788 15.8668 0.845703 15.8916C0.722405 15.9163 0.589517 15.8998 0.447266 15.8408C0.304937 15.7819 0.199552 15.7007 0.129883 15.5977C0.0602816 15.4947 0.0254437 15.3681 0.0253906 15.2168V1.4248C0.0253906 1.04696 0.163384 0.719272 0.44043 0.441406C0.717188 0.163648 1.04283 0.0254959 1.41895 0.0253906ZM1.39453 13.7295L1.4375 13.6826L2.80273 12.1934H15.5215V1.39941H1.39453V13.7295Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.05
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefineIcon);
export default __webpack_public_path__ + "static/media/refine-icon.ff8ebe8dd5dc518567574cce532c0274.svg";
export { ForwardRef as ReactComponent };